var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',_vm._b({class:[
    'checkbox-' + _vm.checkboxSize,
    {'full-width': _vm.isFullWidth}
  ],model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'el-checkbox',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }